export default {
  id: 217,
  title: 'Target #217 - Maze',
  url: 'https://cssbattle.dev/play/217',
  colors: ['#202939', '#556787', '#FFFFFF'],
  solution:
    '<p a><p b><style>p[a],p[b]{position:fixed;margin:0;width:50;height:50;transform:skewy(30deg)}body{background:#202939}p[a]{top:70;left:120;background:#556787;box-shadow:110px 48px #556787}p[b]{top:145;left:155;background:#fff;box-shadow:20px -31px #fff,40px -63px #fff',
}
